import { gql } from '@apollo/client';

export const LIMIT = 30;

export const UPDATE_TESTER_PAYMENT_STATUS = gql`
  mutation UpdateTesterPaymentStatus($testerPaymentId: ID!, $status: TesterPaymentStatusEnum!) {
    updateTesterPaymentStatus(testerPaymentId: $testerPaymentId, status: $status) {
      testerPayment {
        id
        status
      }
    }
  }
`;

export const TESTER_PAYMENTS = gql`
  query TesterPayments($limit: Int, $offset: Int) {
    testerPayments(limit: $limit, offset: $offset) {
      id
      createdAt
      updatedAt
      amount
      convertedAmount
      paypalAccount
      paymentDate
      status
      tester {
        id
        testSessions {
          id
          completedAt
        }
        user {
          id
          testCode
          profile {
            id
            firstName
            lastName
          }
        }
        project {
          id
          testType
          shareCode
          company {
            id
            name
          }
        }
      }
    }
  }
`;
